// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL Reports API (nestjs)
 * API for reports in WL
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentNewWordResponseDto } from './StudentNewWordResponseDto'
import {
  StudentNewWordResponseDtoFromJSON,
  StudentNewWordResponseDtoFromJSONTyped,
  StudentNewWordResponseDtoToJSON,
} from './StudentNewWordResponseDto'

/**
 *
 * @export
 * @interface WordWallsControllerGetStudentNewWord200Response
 */
export interface WordWallsControllerGetStudentNewWord200Response {
  /**
   *
   * @type {Array<StudentNewWordResponseDto>}
   * @memberof WordWallsControllerGetStudentNewWord200Response
   */
  data: Array<StudentNewWordResponseDto>
  /**
   *
   * @type {number}
   * @memberof WordWallsControllerGetStudentNewWord200Response
   */
  total: number
  /**
   *
   * @type {number}
   * @memberof WordWallsControllerGetStudentNewWord200Response
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof WordWallsControllerGetStudentNewWord200Response
   */
  itemsPerPage: number
  /**
   * Additional metadata
   * @type {object}
   * @memberof WordWallsControllerGetStudentNewWord200Response
   */
  meta?: object
}

/**
 * Check if a given object implements the WordWallsControllerGetStudentNewWord200Response interface.
 */
export function instanceOfWordWallsControllerGetStudentNewWord200Response(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value
  isInstance = isInstance && 'page' in value
  isInstance = isInstance && 'itemsPerPage' in value

  return isInstance
}

export function WordWallsControllerGetStudentNewWord200ResponseFromJSON(
  json: any,
): WordWallsControllerGetStudentNewWord200Response {
  return WordWallsControllerGetStudentNewWord200ResponseFromJSONTyped(
    json,
    false,
  )
}

export function WordWallsControllerGetStudentNewWord200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WordWallsControllerGetStudentNewWord200Response {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(StudentNewWordResponseDtoFromJSON),
    total: json['total'],
    page: json['page'],
    itemsPerPage: json['itemsPerPage'],
    meta: !exists(json, 'meta') ? undefined : json['meta'],
  }
}

export function WordWallsControllerGetStudentNewWord200ResponseToJSON(
  value?: WordWallsControllerGetStudentNewWord200Response | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(StudentNewWordResponseDtoToJSON),
    total: value.total,
    page: value.page,
    itemsPerPage: value.itemsPerPage,
    meta: value.meta,
  }
}
